export default __webpack_public_path__ + "static/media/Car.8b09f003.png";